import { takeLatest, all } from 'redux-saga/effects';
import API from '../../services/Api';

/* ------------- Types ------------- */

import { LoginTypes } from '../actions/LoginActions';
import { SignupTypes } from '../actions/SignupActions';
import { ActivationTypes } from '../actions/ActivationActions';
import { ChangePasswordTypes } from '../actions/ChangePasswordActions';
import { ResetPasswordTypes } from '../actions/ResetPasswordActions';
import { ApplicationTypes } from '../actions/ApplicationActions';
import { ConfigTypes } from '../actions/ConfigActions';
import { PaymentTypes } from '../actions/PaymentActions';
import { AppTypes } from '../actions/AppActions';

/* ------------- Sagas ------------- */
import { login, logout } from './LoginSagas';
import {
  signup,
  activateAccount,
  changePassword,
  initResetPassword,
  finishResetPassword,
} from './AccountSagas';
import {
  getApplications,
  getApplication,
  getUsers,
  saveApplication,
  submitApplication,
  validateApplication,
  uploadDocument,
  deleteDocumentSaga,
  sendMessage,
  sendMessageToApplicant,
  downloadApplicationSaga,
} from './ApplicationSagas';
import { getConfiguration } from './ConfigSagas';
import {
  getVisaFees,
  createQuote,
  pay,
  submitPayment,
  getPaymentMethods,
  performCashPaymentFlow,
  performMockPaymentFlow,
  sendPaymentLink,
  markForLocalPayment,
  getPaymentInfo,
  checkIsZeroPayment,
  zeroPay,
} from './PaymentSagas';

/* ------------- API ------------- */

// The API we use is only used from Sagas, so we create it here and pass along
// to the sagas which need it.
const api = API.create();

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  yield all([
    takeLatest(LoginTypes.LOGIN_REQUEST, login, api),
    takeLatest(ConfigTypes.GET_CONFIG_REQUEST, getConfiguration, api),
    takeLatest(PaymentTypes.GET_FEES_REQUEST, getVisaFees, api),
    takeLatest(LoginTypes.LOGOUT_REQUEST, logout, api),
    takeLatest(SignupTypes.SIGNUP_REQUEST, signup, api),
    takeLatest(ActivationTypes.ACTIVATION_REQUEST, activateAccount, api),
    takeLatest(
      ChangePasswordTypes.CHANGE_PASSWORD_REQUEST,
      changePassword,
      api
    ),
    takeLatest(
      ResetPasswordTypes.INIT_RESET_PASSWORD_REQUEST,
      initResetPassword,
      api
    ),
    takeLatest(
      ResetPasswordTypes.FINISH_RESET_PASSWORD_REQUEST,
      finishResetPassword,
      api
    ),
    takeLatest(ApplicationTypes.GET_APPLICATIONS_REQUEST, getApplications, api),
    takeLatest(ApplicationTypes.GET_APPLICATION_REQUEST, getApplication, api),
    takeLatest(ApplicationTypes.GET_USERS, getUsers, api),
    takeLatest(
      [ApplicationTypes.VALIDATE_REQUEST, AppTypes.LANGUAGE_CHANGED],
      validateApplication
    ),
    takeLatest(ApplicationTypes.SAVE_REQUEST, saveApplication, api),
    takeLatest(ApplicationTypes.SUBMIT_REQUEST, submitApplication, api),
    takeLatest(ApplicationTypes.UPLOAD_REQUEST, uploadDocument, api),
    takeLatest(ApplicationTypes.DELETE_DOCUMENT_REQUEST, deleteDocumentSaga, api),
    takeLatest(ApplicationTypes.SEND_MESSAGE_REQUEST, sendMessage, api),
    takeLatest(
      ApplicationTypes.SEND_MESSAGE_TO_APPLICANT_REQUEST,
      sendMessageToApplicant,
      api
    ),
    takeLatest(PaymentTypes.GET_QUOTE_REQUEST, createQuote, api),
    takeLatest(PaymentTypes.PAY_REQUEST, pay, api),
    takeLatest(PaymentTypes.SUBMIT_PAYMENT_REQUEST, submitPayment, api),
    takeLatest(
      PaymentTypes.GET_PAYMENT_METHODS_REQUEST,
      getPaymentMethods,
      api
    ),
    takeLatest(
      PaymentTypes.PERFORM_CASH_PAYMENT_FLOW,
      performCashPaymentFlow,
      api
    ),
    takeLatest(
      PaymentTypes.PERFORM_MOCK_PAYMENT_FLOW,
      performMockPaymentFlow,
      api
    ),
    takeLatest(PaymentTypes.MARK_FOR_LOCAL_PAYMENT, markForLocalPayment, api),
    takeLatest(PaymentTypes.SEND_PAYMENT_LINK, sendPaymentLink, api),
    takeLatest(PaymentTypes.GET_PAYMENT_INFO_REQUEST, getPaymentInfo, api),
    takeLatest(PaymentTypes.SUBMIT_ZERO_PAYMENT, zeroPay, api),
    takeLatest(ApplicationTypes.CHECK_ZERO_PAYMENT, checkIsZeroPayment, api),
    takeLatest(
      ApplicationTypes.DOWNLOAD_APPLICATION_REQUEST,
      downloadApplicationSaga,
      api
    ),
  ]);
}



// WEBPACK FOOTER //
// ./src/state/sagas/index.js